import React from 'react'
import CreateCampaign from './CreateCampaign'
import PromoHeader from 'components/PromoHeader'
import CampaignTable from 'pages/Promo/components/CampaignTable'
import Monitoring from 'pages/Promo/components/Monitoring'
import { withRouter } from 'hooks/withRouter'

export default withRouter(function CampaignDetails({ router: { params: { action, name } } }) {

  return (
    <section>
      {name && <PromoHeader name={name} />}

      {
        action === 'create-campaign' ? (
          <CreateCampaign />
        ) : action === 'monitoring' ?
          <div className="bg-white p-5 rounded-2xl flex flex-col items-center w-full mb-8 lg:w-full">
            <Monitoring />
          </div>
          :
            <div className="bg-white p-5 rounded-2xl flex flex-col items-center w-full mb-8 lg:w-full">
             <CampaignTable />
            </div>

      }


    </section>
  )
})
